import React from "react";
import PropTypes from "prop-types";
import StyledIcon from "./styledIcon";

const ArrowRight = ({ fill, ...props }) => (
  <StyledIcon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M15.875 9l-3.88 3.88L8.115 9a.996.996 0 10-1.41 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59a.996.996 0 000-1.41c-.39-.38-1.03-.39-1.42 0z"
      fill={fill}
    />
  </StyledIcon>
);

ArrowRight.propTypes = {
  fill: PropTypes.string
};

ArrowRight.defaultProps = {
  fill: "white"
};

export default ArrowRight;
